import React, { useState, useEffect } from "react";

export default function WORLDWARStest(props) {
  const correctAnswers = [0, 2, 1, 3, 0, 3, 1, 1, 0, 1, 0, 0, 3, 1, 0, 0, 1, 0, 1, 0, 0, 0, 2, 2, 1];
  const que = {
    q1: {
      string: "1. Which event triggered the start of World War I?",
      options: ["Assassination of Archduke Franz Ferdinand", "Invasion of Poland", "Bombing of Pearl Harbor", "Signing of the Treaty of Versailles"],
      ans: 0
    },
    q2: {
      string: "2. Which country was NOT part of the Allied Powers during World War I?",
      options: ["France", "Italy", "Germany", "Russia"],
      ans: 2
    },
    q3: {
      string: "3. Who was the leader of Germany during World War I?",
      options: ["Adolf Hitler", "Kaiser Wilhelm II", "Winston Churchill", "Woodrow Wilson"],
      ans: 1
    },
    q4: {
      string: "4. Which battle is often considered the turning point of World War I?",
      options: ["Battle of Stalingrad", "Battle of the Bulge", "Battle of the Somme", "Battle of Verdun"],
      ans: 3
    },
    q5: {
      string: "5. Which treaty officially ended World War I?",
      options: ["Treaty of Versailles", "Treaty of Brest-Litovsk", "Treaty of Trianon", "Treaty of Sevres"],
      ans: 0
    },
    q6: {
      string: "6. Which country was NOT part of the Axis Powers during World War II?",
      options: ["Germany", "Italy", "Japan", "France"],
      ans: 3
    },
    q7: {
      string: "7. The Battle of Britain primarily took place in which year?",
      options: ["1939", "1940", "1941", "1942"],
      ans: 1
    },
    q8: {
      string: "8. The bombing of which city marked the beginning of the nuclear age during World War II?",
      options: ["London", "Hiroshima", "Berlin", "Tokyo"],
      ans: 1
    },
    q9: {
      string: "9. Which event led to the United States entering World War II?",
      options: ["Pearl Harbor attack", "Battle of Stalingrad", "Invasion of Normandy", "Atomic bombings of Hiroshima and Nagasaki"],
      ans: 0
    },
    q10: {
      string: "10. Which battle is often considered the turning point of World War II in Europe?",
      options: ["Battle of Midway", "Battle of Stalingrad", "D-Day Invasion", "Battle of the Bulge"],
      ans: 1
    },
    q11: {
      string: "11. Who was the Prime Minister of the United Kingdom during most of World War II?",
      options: ["Winston Churchill", "Neville Chamberlain", "Clement Attlee", "Margaret Thatcher"],
      ans: 0
    },
    q12: {
      string: "12. The Holocaust primarily targeted which group of people?",
      options: ["Jews", "Germans", "Italians", "British"],
      ans: 0
    },
    q13: {
      string: "13. Which country was NOT part of the Big Three allied powers during World War II?",
      options: ["United States", "Soviet Union", "United Kingdom", "France"],
      ans: 3
    },
    q14: {
      string: "14. Which battle marked the final major offensive by the German army during World War II?",
      options: ["Battle of Berlin", "Battle of the Bulge", "Battle of Stalingrad", "Battle of Kursk"],
      ans: 1
    },
    q15: {
      string: "15. What was the code name for the Allied invasion of Normandy during World War II?",
      options: ["Operation Overlord", "Operation Barbarossa", "Operation Neptune", "Operation Market Garden"],
      ans: 0
    },
    q16: {
      string: "16. Which country was the first to declare war in World War II?",
      options: ["Germany", "Poland", "France", "United Kingdom"],
      ans: 1
    },
    q17: {
      string: "17. The Treaty of Versailles placed heavy reparations and restrictions on which country?",
      options: ["Italy", "Germany", "Austria-Hungary", "Ottoman Empire"],
      ans: 1
    },
    q18: {
      string: "18. Which battle is often considered the turning point of World War II in the Pacific?",
      options: ["Battle of Midway", "Battle of Okinawa", "Battle of Iwo Jima", "Pearl Harbor"],
      ans: 0
    },
    q19: {
      string: "19. Which country suffered the most casualties during World War II?",
      options: ["Germany", "Soviet Union", "United Kingdom", "United States"],
      ans: 1
    },
    q20: {
      string: "20. Who was the President of the United States during most of World War II?",
      options: ["Franklin D. Roosevelt", "Harry S. Truman", "Dwight D. Eisenhower", "Woodrow Wilson"],
      ans: 0
    },
    q21: {
      string: "21. Which country was NOT a member of the League of Nations?",
      options: ["United States", "Germany", "Soviet Union", "France"],
      ans: 1
    },
    q22: {
      string: "22. Which event is often considered the immediate cause of the outbreak of World War II?",
      options: ["Invasion of Poland", "Pearl Harbor attack", "Assassination of Archduke Franz Ferdinand", "Signing of the Treaty of Versailles"],
      ans: 0
    },
    q23: {
      string: "23. The Battle of the Atlantic primarily involved which two naval powers?",
      options: ["United States and Japan", "Germany and United Kingdom", "United States and Germany", "Japan and United Kingdom"],
      ans: 2
    },
    q24: {
      string: "24. Which country was NOT part of the Treaty of Tripartite Pact, forming the Axis Powers?",
      options: ["Italy", "Japan", "Soviet Union", "Germany"],
      ans: 2
    },
    q25: {
      string: "25. Who was the leader of the Soviet Union during World War II?",
      options: ["Vladimir Lenin", "Joseph Stalin", "Mikhail Gorbachev", "Leon Trotsky"],
      ans: 1
    }
  };


  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>KNOWLEDGE TEST ON <span>WORLD-WARS</span></h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1>
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
            <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
